<template>
  <b-container fluid class="animated fadeIn">
    <h1>Informações Legais</h1>
    <b-row>
      <b-col sm="12" md="12">
      <!-- <b-card title="Sobre Este Sistema"> -->
        <b-card header="Sobre Este Sistema">
        <p class="ml-4">
          Este sistema foi desenvolvido pela <a href="http://www.celepar.pr.gov.br">Companhia de Tecnologia da Informação e Comunicação do Paraná - CELEPAR</a>,
          uma sociedade de economia mista de capital fechado, cujo maior acionista é o <a href="http://www.pr.gov.br">Governo do Paraná</a>.
        </p>
      </b-card>

      <b-card header="Tecnologias Utilizadas">
        <p class="ml-4">
          <ul>
            <li>Vue.js: <a href="https://vuejs.org/">https://vuejs.org/</a></li>
            <li>CoreUI: <a href="https://coreui.io/">https://coreui.io/</a></li>
            <li>Bootstrap: <a href="https://getbootstrap.com/">https://getbootstrap.com/</a></li>
            <li>BootstrapVue: <a href="https://bootstrap-vue.js.org/docs">https://bootstrap-vue.js.org/docs</a></li>
            <li>Font Awesome: <a href="https://fontawesome.com/">https://fontawesome.com/</a></li>
          </ul>
        </p>
      </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "InformacoesLegais"
};
</script>
